import cx from "classnames"
import React, {useEffect, useRef, useState} from "react";
import styles from "./HomeTitle.module.css"
import {useInView} from "framer-motion";

const HomeTitle = () => {
    const refRow1 = useRef()
    const isRow1InView = useInView(refRow1, {once: true})
    const [isMounted, setIsMounted] = useState(false)
    useEffect(() => {
        setIsMounted(true)
    }, [])
    return(
        <div
            className={cx(
                styles.topContent,
                "d-flex",
                "align-items-center",
                "justify-content-center",
                "flex-column"
            )}
        >
            <h1
                style={{
                    transform: isMounted ? (isRow1InView ? "none" : "translateY(-20px)") : "none",
                    opacity: isMounted ? (isRow1InView ? 1 : 0) : 1,
                    transition: "all ease 1400ms"
                }}
                className={cx(styles.topContentH1)}>
                گروه تجارت الکترونیک دیجی‌کالا
            </h1>
            <div ref={refRow1}></div>
            <p
                style={{
                    transform: isMounted ? (isRow1InView ? "none" : "translateY(20px)") : "none",
                    opacity: isMounted ? (isRow1InView ? 1 : 0) : 1,
                    transition: "all ease 1400ms",
                    transitionDelay: "0.3s"
                }}
                className={cx(styles.topContentP)}>
                گروه تجارت الکترونیک دیجی‌کالا اکنون به اکوسیستمی کامل برای تمامی
                کسب‌وکارهای آنلاین تبدیل شده است. رویکرد گروه دیجی‌کالا تکمیل زنجیره
                خلق ارزش برای اقتصاد دیجیتال ایران بوده و در این مسیر، زیرساخت‌های
                لازم برای پاسخگویی به نیازهای کسب‌وکارها را فراهم کرده است.
            </p>
        </div>
    )
}
export default HomeTitle